<template>
  <div>
    <vs-input
        v-validate="'required|email|min:3'"
        data-vv-validate-on="blur"
        name="email"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Email"
        v-model="email"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

    <!-- v-validate="'required|min:6|max:6'" -->
    <vs-input
        data-vv-validate-on="blur"        
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/pages/forgot-password">Forgot Password?</router-link>
    </div>

    <div class="flex flex-wrap justify-between mb-3">

      <div class="dropdown-button-container">
        <vs-button class="" type="filled" disabled>Register</vs-button>
        <!-- <vs-button class="btnx" type="filled">Register</vs-button>
        <vs-dropdown>
          <vs-button class="btn-drop" type="filled" icon="expand_more"></vs-button>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="registerUser">Service Provider</vs-dropdown-item>
            <vs-dropdown-item disabled>Resident</vs-dropdown-item>
            <vs-dropdown-item disabled>Owner</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
      </div>

      <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>
import axios from '../../../axios'
import router from '../../../router'
import EventBus from '../EventBus'

export default {
  data () {
    return {
      email: '',
      password: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    async loginJWT () {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading()

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password
        }
      }

      await axios.post('/user/login', payload)
        .then((res) => { 
          // this.$vs.loading.close() 

          if (res['data']['error'] !== 'not_exist') {            
            localStorage.setItem('userAllData', res.data[0]['userAllData'])
            localStorage.setItem('usertoken', res.data[0]['token'])
            localStorage.setItem('usertokenexp', res.data[0]['exp'])
            localStorage.setItem('usersession', 'active')

            console.log("localStorage.getItem('usertoken') ", localStorage.getItem('usertoken'))
            console.log("localStorage.getItem('usertokenexp') ", localStorage.getItem('usertokenexp'))
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: 'User does not exist',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          }

          // this.email = ''
          // this.password = ''
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

        var propertyRes = await axios.get(`/property/list`, {
            headers: { 'Authorization': localStorage.usertoken }
        })

        localStorage.setItem('selectedParentOrgRef', propertyRes['data'].length == 0 ? 0 : propertyRes['data'][0]['ref'])
        localStorage.setItem('selectedParentOrgId', propertyRes['data'].length == 0 ? 0 : propertyRes['data'][0]['id'])

        console.log('localStorage.selectedParentOrgRef ', localStorage.selectedParentOrgRef)
        console.log('localStorage.selectedParentOrgId ', localStorage.selectedParentOrgId)
      // this.$store.dispatch('auth/loginJWT', payload)
      //   .then(() => { this.$vs.loading.close() })
      //   .catch(error => {
      //     this.$vs.loading.close()
      //     this.$vs.notify({
      //       title: 'Error',
      //       text: error.message,
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'danger'
      //     })
      //   })

      await axios.get('/api/insight/auth', {
        headers: { 'Authorization': localStorage.usertoken }
      }).then((result) => {
        localStorage.removeItem('Insight_URL')
        localStorage.setItem('Insight_URL', result.data.Insight_URL)
         
        setTimeout(() => {
          // router.push({ name: 'dashboard-analytics' })
          window.location.href = "/dashboard/analytics";
          this.emitMethod()
        },1000)          
    
        return result.data.Insight_URL
      })
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/vendor/register').catch(() => {})
    }
  },
  mounted () {
    localStorage.removeItem('usertoken')
    localStorage.removeItem('usertokenexp')   
  }
}

</script>


<style lang="scss">
.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, .2);
  }
}
</style>